import { ReactNode, forwardRef, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Slide,
  Typography
} from '@mui/material';

import { Icon, IconifyIcon } from '@iconify/react';
import { useTranslation } from '../utils/i18n';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

interface Props {
  icon?: string | IconifyIcon;
  title?: string;
  content?: ReactNode;
  label?: string;
  color?: any;
  onAgree?: () => void;
  onDisagree?: () => void;
  disabled?: boolean;
  className?: string;
}

const DialogIconButton: React.FC<Props> = ({
  icon,
  title,
  content,
  label,
  color,
  onAgree,
  onDisagree,
  className,
  disabled,
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleClickOpen = (e: any) => {
    setOpen(true);
    e.stopPropagation();
  };

  const handleClose = (e: any, agree: any) => {
    setOpen(false);
    if (agree && typeof onAgree === 'function') onAgree();
    else if (!agree && typeof onDisagree === 'function') onDisagree();
    e.stopPropagation();
  };

  return (
    <div className={className}>
      {icon ? (
        <IconButton onClick={handleClickOpen}>
          <Icon icon={icon} />
        </IconButton>
      ) : (
        <Button variant="outlined" color={color} onClick={handleClickOpen} disabled={disabled} {...rest}>
          {label}
        </Button>
      )}

      <Dialog
        open={open}
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="inherit" onClick={(e) => handleClose(e, false)}>
            <Typography>{t('common:cancel')}</Typography>
          </Button>
          <Button variant="contained" color={color} onClick={(e) => handleClose(e, true)}>
            <Typography>{t('common:accepted')}</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogIconButton;
